import { BrowserRouter, Routes, Route } from "react-router-dom";
import Environnement from "../pages/Environnement/Environnement";
import Agriculture from "../pages/Agriculture/Agriculture";
import Nutrition from "../pages/Nutriiton/Nutrition";
import Finance from "../pages/Finance/Finance";

import Home from "../pages/Home/Home";
// import About from "../pages/About/About";
// import Contact from "../pages/Contact/Contact";
// import Login from "../pages/Login/Login";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/contact" element={<Contact />} /> */}
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/finance" element={<Finance />} />
        <Route path="/environnement" element={<Environnement />} />
        <Route path="/agriculture" element={<Agriculture />} />
        <Route path="/nutrition" element={<Nutrition />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;